module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/battle-unique-disabled-hover.95289dce.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/battle-unique-disabled-hover.png
// module id = 3424
// module chunks = 11